module.exports = __webpack_public_path__ + "static/media/enso_login_image.f0ef76f1.jpg";